// External Dependencies:
import zenscroll from 'zenscroll'

// Internal Dependencies:
import { doRequest } from 'utilities/request'

// Redux:
import * as reduxTickets from 'actions/tickets'

export function setData( data ) {
	return {
		type: 'SET_DATA',
		payload: data
	}
}

export function receiveAccountData( data ) {
	return {
		type: 'RECEIVE_ACCOUNT_DATA',
		payload: data
	}
}

export function getUserData() {
	return function( dispatch, getState ) {
		return doRequest( `${siteData.api_base_url}user`, {
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true
		} )
			.then( json => {
				dispatch( receiveAccountData( json ) )
				dispatch( reduxTickets.getTickets() )
			} )
			.catch( error => {
				dispatch( receiveAccountData( false ) )
			} )
	}
}

export function receiveContactsData( data ) {
	return {
		type: 'RECEIVE_CONTACTS_DATA',
		payload: data
	}
}

export function getContactsData( page, perPage, search ) {
	return function( dispatch, getState ) {
		let url = `${siteData.api_base_url}contacts?page=${page}&per_page=${perPage}`

		if ( search ) {
			url += `&search=${search}`
		}

		return doRequest( url, {
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true
		} )
			.then( json => {
				dispatch( receiveContactsData( json ) )
			} )
			.catch( error => {

			} )
	}
}

/**
 * Save
 */

export function setDirtyState( value ) {
	return {
		type: 'SET_DIRTY_STATE',
		payload: value
	}
}

export function setSaveProcessing() {
	return {
		type: 'SET_SAVE_PROCESSING'
	}
}

export function setSaveProcessed() {
	return {
		type: 'SET_SAVE_PROCESSED'
	}
}

export function setSaveSuccess( json ) {
	return {
		type: 'SET_SAVE_SUCCESS',
		payload: json
	}
}

export function setSaveError( json ) {
	return {
		type: 'SET_SAVE_ERROR',
		payload: json
	}
}

export function setSaveFinishing() {
	return {
		type: 'SET_SAVE_FINISHING'
	}
}

export function unsetSaveProcessed() {
	return {
		type: 'UNSET_SAVE_PROCESSED'
	}
}

function saveStateSuccessful( dispatch, callback = false ) {
	setTimeout( () => {
		dispatch( setSaveProcessed() )

		if ( callback ) {
			callback()
		}

		setTimeout( () => {
			dispatch( setSaveSuccess() )

			setTimeout( () => {
				dispatch( setSaveFinishing() )

				setTimeout( () => {
					dispatch( unsetSaveProcessed() )
				}, 500 )
			}, 2000 )
		}, 200 )
	}, 1000 )
}

function saveStateUnsuccessful( dispatch, message, callback = false ) {
	setTimeout( () => {
		dispatch( setSaveProcessed() )

		if ( callback ) {
			callback()
		}

		setTimeout( () => {
			dispatch( setSaveError( message ) )

			setTimeout( () => {
				dispatch( setSaveFinishing() )

				setTimeout( () => {
					dispatch( unsetSaveProcessed() )
				}, 500 )
			}, 2000 )
		}, 200 )
	}, 1000 )
}

export function saveProfile( data, history ) {
	return function( dispatch, getState ) {
		dispatch( setSaveProcessing() )

		return doRequest( `${siteData.api_base_url}save-profile`, {
			method: 'POST',
			headers: {
				'X-WP-Nonce': siteData.wp_rest_nonce
			},
			withCredentials: true,
			data: {
				...data
			}
		} )
			.then( json => {
				dispatch( receiveAccountData( json ) )

				saveStateSuccessful( dispatch )

				if ( json.is_new ) {
					setTimeout( () => {
						history.push( '/' )
					}, 1000 )
				}
			} )
			.catch( error => {
				saveStateUnsuccessful( dispatch, error.data.message )
			} )
	}
}

export function deleteAccount() {
	return function( dispatch, getState ) {
		return doRequest( `${siteData.api_base_url}delete-account`, {
				method: 'DELETE',
				headers: {
					'X-WP-Nonce': siteData.wp_rest_nonce
				},
				withCredentials: true
			} )
			.then( response => {
				dispatch( receiveAccountData( {
					deleted: true
				} ) )
			} )
			.catch( error => {
				if ( error.data ) {
					console.error( error.data, 'error.data' )
				}
			} )
	}
}

export function activateAccount( user_id, key ) {
	return function( dispatch, getState ) {
		return doRequest( `${siteData.api_base_url}activate`, {
				method: 'POST',
				data: {
					user_id: user_id,
					key: key
				}
			} )
			.then( response => {
				dispatch( receiveAccountData( response.user ) )
			} )
			.catch( error => {
				if ( error.data ) {
					dispatch( showSignupError( error.data.message ) )
				}
			} )
	}
}

export function showSignupError( message ) {
	return {
		type: 'SHOW_SIGNUP_ERROR',
		payload: message
	}
}
